/**
 * The /v3/post representation of ProductDetails is different from previous versions
 * I'm colocating the types here to make migration to Pinia a little easier
 * https://backstage.ltkoperator.com/catalog/default/api/ltk-post-service/definition
 */

type productDetailRetailer = {
  id: string;
  parentId: string;
  displayName: string;
  sourceId: number;
};

export interface ProductDetail extends CoreModel {
  advertiserName: string;
  advertiserParentId: string;
  available: boolean;
  id: string;
  name: string;
  price: number;
  hasVariants: boolean;
  imageUrl: string;
  catalogRetailerProductId?: string;
  catalogRetailerProductActive?: boolean;
  catalogRetailerProductUpdatedAt?: string;
  currency?: string;
  localPrice?: number;
  percentChange: string;
  retailerId: string;
  retailerIds: string[];
  retailers: productDetailRetailer[];
  minPrice?: string;
  minSalePrice?: string;
  maxPrice?: string;
  maxSalePrice?: string;
}

export interface ProductDetailV3 extends CoreModel {
  advertiserName: string;
  advertiserParentId: string;
  catalogRetailerProductAvailable: boolean;
  id: string; // this is a product_reference_id
  name: string;
  price: number;
}

export type ProductDetailMap = ModelMap<ProductDetail>;

export interface ManyProductDetailsResponse {
  productDetails: ProductDetail[];
}
